import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { massiveManagementCenterChangeAction } from "@icarius-pages/myPeople/actions";
import { getEditableFields } from "../../selectors";

const gridStyle = { height: 75, padding: "0px 10px" };

const ManagementCenterDialog = (props) => {

  const {
    open,
    isLoading,
    employees,
    handleAfterSubmit,
    handleClose,
  } = props;

  const [center, setCenter] = useState("");

  const editableFields = useSelector(getEditableFields);

  const centerArray = editableFields.find(item => item.name === 'CENTRO DE GESTIÓN').options
    .map((item) => ({ key: item.id, value: item.value }));

  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(massiveManagementCenterChangeAction({
      codes: employees.map(item => item.code),
      center,
    }))
      .then((resp) => {
        if (resp.status === 200) {
          handleAfterSubmit(resp?.data?.showAlert);
        }
        handleClose();
      });
  };

  if (isLoading) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("managementCenterChanges")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container>
            <Grid container item alignItems="center" xs={12} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id={`label-turn`}>{getLocalizedString("managementCenter")}</InputLabel>
                <Select
                  value={center}
                  labelId={`label-turn`}
                  id={`select-turn`}
                  onChange={(e) => setCenter(e.target.value)}
                  margin={"none"}
                >
                  {
                    centerArray.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Typography className="whiteText" style={{ margin: 10, fontWeight: 500 }}>
            {getLocalizedString("turnChangeQuestion", { length: employees.length })}
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
          <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ManagementCenterDialog;
